export default __webpack_public_path__ + "static/media/reversedNum.441c15db.svg";